import React from 'react';
import PropTypes from 'prop-types';
import styled, { useTheme } from 'styled-components';

import { FlexBoxSpaceBetween } from '@ecp/common/src/layouts/flex/styled';
import { TextBox } from '@ecp/common/src/text/TextBox';
import { TextBoxButton } from '@ecp/common/src/text/TextBoxButton';

const SearchHistoryHeader = ({ handleDeleteAll }) => {
  const theme = useTheme();

  return (
    <FlexBoxSpaceBetween width={'100%'}>
      <SearchKeyword>최근 검색어</SearchKeyword>
      <TextBoxButton
        size={theme.font.size.$13}
        weight={theme.font.weight.demiLight}
        color={theme.color.text.sub}
        decoration={'underline'}
        hoverDecoration={'underline'}
        onClick={handleDeleteAll}
        height={'16px'}
        width={'55px'}
      >
        전체삭제
      </TextBoxButton>
    </FlexBoxSpaceBetween>
  );
};

export default SearchHistoryHeader;

SearchHistoryHeader.propTypes = {
  handleDeleteAll: PropTypes.func,
};

const SearchKeyword = styled(TextBox)`
  font-size: ${(props) => props.theme.font.size.title};
  font-weight: ${(props) => props.theme.font.weight.bold};
  width: 87px;
  height: 22px;
  white-space: nowrap;
`;
